import React, { useEffect, useState } from "react";
import { get } from "../../../utils/api";
import MultiColumns from "./MultiColumns";
import { companyId } from "../../../utils/companyId";
import { Typography } from "@mui/material";

const ESGBaselineYear = ({ isEditing }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        console.log("Fetching data..."); // Add here too

        const [esgBaseline] = await Promise.all([
          get(`esg-baseline/${companyId}`),
        ]);

        setData(esgBaseline?.data?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, []);

  const dataSet = {
    title: "ESG Baseline Year",
    data: data,
    url: "/esg-baseline",
    questionary: [{ key: "year", question: "Define your ESG Baseline Year" }],
  };
  return (
    <>
     <Typography
        sx={{
          // color: "#488257",
          fontWeight: 600,
          fontSize: "20px",
          lineHeight: "24px",
          textTransform: "uppercase",
          fontFamily: "inter",
          mt: "1rem",
        }}
      >
        ESG Baseline
      </Typography>
      <MultiColumns
        title={dataSet.title}
        questionary={dataSet.questionary}
        columns={dataSet.columns}
        url={dataSet?.url}
        data={dataSet.data}
        isEditing={isEditing}
      />
    </>
  );
};

export default ESGBaselineYear;
